import LoginForm from "../features/login/LoginForm";

const Login = () => {
    return(
        <div className='login'>
            <div className='login-box'>
                <div className='title'>
                    <span>اداره کل امور عشایر خراسان جنوبی</span><img alt='office-icon' className='icon' src='/Untitled.jpg' />
                </div>
                <div className='description'>
                    <h2>ورود به پنل کاربری</h2>
                    <p>خوش آمدید! لطفا با نام کاربری و رمز عبور خود وارد شوید</p>
                </div>
                <LoginForm />
                <p>برای کارایی بهتر، از مرورگر <span className='chrome-text'>گوگل کروم</span> استفاده نمایید</p>
            </div>
        </div>
    )
}

export default Login